import { AdjustmentType } from '../adjustment-type';
import { TbaModalsPayload } from './tba-modals-payload';

export class ApplyAdjustmentModalPayload extends TbaModalsPayload {
  adjustmentType: AdjustmentType;
  appliedAdjustmentId: number;
  isAmount: boolean;
}
